// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dFoOB_f0EAwTkmG2 {
	width: 180px;
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/Cards/components/EditMenu/EditMenu.module.css"],"names":[],"mappings":"AAAA;CACC,YAAY;AACb","sourcesContent":[".menu {\n\twidth: 180px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu": `dFoOB_f0EAwTkmG2`
};
export default ___CSS_LOADER_EXPORT___;
